<script setup lang="ts">
  import type { ProductVariantResource } from '@storefront/resources';

  interface Props {
    variant: ProductVariantResource;
  }

  defineProps<Props>();
</script>
<template>
  <dl class="product-description-specification">
    <div class="product-description-specification__item" v-for="attribute in variant.attributes">
      <dt class="product-description-specification__term">{{ attribute.name }}</dt>
      <dd class="product-description-specification__details">{{ attribute.value }}</dd>
    </div>
  </dl>
</template>

<style>
  :root {
    --product-description-specification-item-border-radius: var(--border-radius);
    --product-description-specification-item-background: none;
    --product-description-specification-item-odd-backgrouns: var(--secondary-background);
    --product-description-specification-item-border: none;
    --product-description-specification-item-grid-template-columns: repeat(2, 1fr);
    --product-description-specification-item-padding: 0.5rem;
  }
</style>
<style scoped lang="scss">
  .product-description-specification {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    font-size: 0.875rem;

    &__item {
      display: grid;
      grid-template-columns: var(--product-description-specification-item-grid-template-columns);
      column-gap: 0.5rem;
      padding: var(--product-description-specification-item-padding);
      background: var(--product-description-specification-item-background);
      border-radius: var(--product-description-specification-item-border-radius);
      border-bottom: var(--product-description-specification-item-border);

      &:nth-child(odd) {
        background: var(--product-description-specification-item-odd-backgrouns);
      }
    }

    &__term {
      font-weight: var(--font-weight-semi);

      &::after {
        content: ':';
      }
    }

    @media(max-width: 992px) {
      font-size: 0.75rem;
      padding: 0 0.625rem;
    }
  }
</style>
